import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AttendanceService from '../../services/AttendanceService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle'
    
};

export const fetchTeamAttendanceDashbaord = createAsyncThunk('teamAttendanceDashbaord', async () => {
    const response = await AttendanceService.getTeamAttendanceDashboard();
    return response;
});


export const TeamAttendanceDashbaordSlice = createSlice({
    name: 'teamAttendanceDashbaord',
    initialState,
    reducers: {
        addTeamAttendanceDashbaordConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToTeamAttendanceDashbaordConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTeamAttendanceDashbaord.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTeamAttendanceDashbaord.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
            
    }
});


export const selectTeamAttendanceDashbaord = (state) => state.teamAttendanceDashbaord.data;
